import { api } from "@/api";
import { IVisitStat } from "@/interfaces";
import router from "@/router";
import {
  getLocalProject,
  getLocalStoragePreRoute,
  getLocalStorageProject,
  getLocalToken,
  removeLocalToken,
  saveLocalProject,
  saveLocalStorageProject,
  saveLocalToken,
} from "@/utils";
import { AxiosError } from "axios";
import { getStoreAccessors } from "typesafe-vuex";
import { ActionContext } from "vuex";
import { store } from "..";
import { State } from "../state";
import { readMyLastProject } from "./getters";
import {
  commitAddNotification,
  commitRemoveNotification,
  commitSetLoggedIn,
  commitSetLogInError,
  commitSetToken,
  commitSetUserProfile,
  commitSetMyLastProject,
  commitSetUsers,
  commitSetAllIndexes,
  commitSetMobaProjects,
  commitSetHeroSkin,
  commitSetStaffInfo,
  commitSetTaskLogs,
  commitSetLoggedInUser
} from "./mutations";
import { AppNotification, MainState } from "./state";

type MainContext = ActionContext<MainState, State>;

export const actions = {
  async actionLogIn(
    context: MainContext,
    payload: {
      username: string;
      password: string;
      tapd_token: any;
      login_type: any;
    }
  ) {
    try {
      const response = await api.logInGetToken(
        payload.username,
        payload.password,
        payload.tapd_token,
        payload.login_type
      );
      const token = response.data.access_token;
      if (token) {
        saveLocalToken(token);
        commitSetToken(context, token);
        commitSetLoggedIn(context, true);
        commitSetLogInError(context, false);
        await dispatchGetUserProfile(context);
        await dispatchGetMyLastProject(context);
        // 仅当本地无项目时才用服务端 last_visit_project 兜底，避免多标签页 token 重新鉴权互相覆盖
        if (!getLocalProject() || getLocalProject() === "null") {
          saveLocalProject(String(readMyLastProject(store)));
        }
        saveLocalStorageProject(String(readMyLastProject(store)));
        await dispatchRouteLoggedIn(context);
        // commitAddNotification(context, {content: 'Logged in', color: 'success'});
      } else {
        commitSetLogInError(context, true);
        await dispatchLogOut(context);
      }
    } catch (err: any) {
      if (err.response!.status === 403) {
        // commitSetLoggedIn(context, true);
        commitSetLogInError(context, true);
        await dispatchLogOut(context);
        // await router.push("/403");        //当status为403时, 响应拦截器自动跳转到403页面, 详情请参见router/index.ts
      } else {
        commitSetLogInError(context, true);
        await dispatchLogOut(context);
      }
    }
  },
  async actiontWereportLogIn(
    context: MainContext,
    payload: {
      wereport_token: string;

    }
  ) {
    try {
      console.log(4444)
      const response = await api.logInGetWereportToken(
        payload.wereport_token
      );
      const token = response.data.access_token;
      if (token) {
        saveLocalToken(token);
        commitSetToken(context, token);
        commitSetLoggedIn(context, true);
        commitSetLogInError(context, false);
        await dispatchGetUserProfile(context);
        await dispatchGetMyLastProject(context);
        // 仅当本地无项目时才用服务端 last_visit_project 兜底，避免多标签页 token 重新鉴权互相覆盖
        if (!getLocalProject() || getLocalProject() === "null") {
          saveLocalProject(String(readMyLastProject(store)));
        }
        saveLocalStorageProject(String(readMyLastProject(store)));
        await dispatchRouteLoggedIn(context);
        // commitAddNotification(context, {content: 'Logged in', color: 'success'});
      } else {
        commitSetLogInError(context, true);
        await dispatchLogOut(context);
      }
    } catch (err: any) {
      if (err.response!.status === 403) {
        // commitSetLoggedIn(context, true);
        commitSetLogInError(context, true);
        await dispatchLogOut(context);
        // await router.push("/403");        //当status为403时, 响应拦截器自动跳转到403页面, 详情请参见router/index.ts
      } else {
        commitSetLogInError(context, true);
        await dispatchLogOut(context);
      }
    }
  },
  async actionWechatLogIn(
    context: MainContext,
    payload: {
      code: string;
    }
  ) {
    try {
      const response = await api.wechatLogInGetToken(payload.code);
      const token = response.data.access_token;
      if (token) {
        saveLocalToken(token);
        commitSetToken(context, token);
        commitSetLoggedIn(context, true);
        commitSetLogInError(context, false);
        await dispatchGetUserProfile(context);
        await dispatchGetMyLastProject(context);
        // 仅当本地无项目时才用服务端 last_visit_project 兜底，避免多标签页 token 重新鉴权互相覆盖
        if (!getLocalProject() || getLocalProject() === "null") {
          saveLocalProject(String(readMyLastProject(store)));
        }
        saveLocalStorageProject(String(readMyLastProject(store)));
        await dispatchRouteLoggedIn(context);
        // commitAddNotification(context, {content: 'Logged in', color: 'success'});
      } else {
        commitSetLogInError(context, true);
        await dispatchLogOut(context);
      }
    } catch (err) {
      if (err.response!.status === 403) {
        commitSetLoggedIn(context, true);
        // await router.push("/403");        //当status为403时, 响应拦截器自动跳转到403页面, 详情请参见router/index.ts
      } else {
        commitSetLogInError(context, true);
        await dispatchLogOut(context);
      }
    }
  },
  async actionGetUsers(context: MainContext) {
    try {
      const response = await api.getUsers(context.state.token);
      if (response.data) {
        commitSetUsers(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetAllIndexes(
    context: MainContext,
    payload: { project: number }
  ) {
    try {
      const response = await api.getAllIndexes(
        context.state.token,
        payload.project
      );
      if (response.data) {
        commitSetAllIndexes(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetUserProfile(context: MainContext) {
    try {
      const response = await api.getMe(context.state.token);
      if (response.data) {
        commitSetUserProfile(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUpdateUserProfile(context: MainContext, payload: any) {
    try {
      const loadingNotification = { content: "saving", showProgress: true };
      commitAddNotification(context, loadingNotification);
      const response = (
        await Promise.all([
          api.updateMe(context.state.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetUserProfile(context, response.data);
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, {
        content: "Profile successfully updated",
        color: "success",
      });
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionCheckLoggedIn(context: MainContext) {
    if (!context.state.isLoggedIn) {
      let token = context.state.token;
      if (!token) {
        const localToken = getLocalToken();
        // const localProject: any = getLocalProject();
        // commitSetMyLastProject(context, parseInt(localProject));
        if (localToken) {
          commitSetToken(context, localToken);
          token = localToken;
        }
      }
      if (token) { //如果token存在，获取用户信息
        try {
          const response = await api.getMe(token);
          commitSetLoggedIn(context, true);
          commitSetLoggedInUser(context, response.data);
          commitSetUserProfile(context, response.data);
        } catch (error) {
          await dispatchRemoveLogIn(context);
        }
      } else {
        await dispatchRemoveLogIn(context);
      }
    }
  },
  async actionRemoveLogIn(context: MainContext) {
    removeLocalToken();
    commitSetToken(context, "");
    commitSetLoggedIn(context, false);
  },
  async actionLogOut(context: MainContext) {
    await dispatchRemoveLogIn(context);
    // await dispatchRouteLogOut(context);
  },
  async actionUserLogOut(context: MainContext) {
    await dispatchLogOut(context);
    commitAddNotification(context, { content: "Logged out", color: "success" });
  },
  actionRouteLogOut(context: MainContext) {
    // if (router.currentRoute.path !== '/login') {
    router.push("/login_new");
    // }
  },
  async actionCheckApiError(context: MainContext, payload: AxiosError) {
    if (payload.response!.status === 401) {
      await dispatchLogOut(context);
    }
    if (payload.response!.status === 400 || payload.response!.status === 500) {
      commitAddNotification(context, {
        content: payload.message,
        color: "error",
      });
    }
  },
  actionRouteLoggedIn(context: MainContext) {
    // 优先停留在当前标签页正在访问的路由：
    // 用户可能在某个业务页面因 token 过期触发重新鉴权（如点击查询），
    // 此时应回到当前页面而不是 localStorage.preRoute 指向的其它标签页页面。
    const current = router.currentRoute.value;
    const currentPath = current?.path;
    const isAuthPage =
      !currentPath ||
      currentPath === "/" ||
      currentPath === "/login" ||
      currentPath === "/login_new" ||
      current.name === "Login" ||
      current.name === "LoginNew" ||
      current.name === "Home";

    if (!isAuthPage) {
      // 当前就在业务页面，重新登录后刷新当前页即可
      router.replace({
        path: currentPath,
        query: current.query,
        hash: current.hash,
      });
      return;
    }

    // 当前在登录页/首页等无业务上下文页面，才回退到上次访问路由
    const curr = getLocalStoragePreRoute();
    if (curr == null) {
      router.push("/");
    } else {
      const currlist = curr.split("?");
      const path = currlist[0];
      const params = currlist[1].split("&");
      const query = {};
      params.map((item) => (query[item.split("=")[0]] = item.split("=")[1]));
      router.push({ path: path, query: query });
      // router.push({ path: curr });
    }

    // }
  },
  async removeNotification(
    context: MainContext,
    payload: { notification: AppNotification; timeout: number }
  ) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commitRemoveNotification(context, payload.notification);
        resolve(true);
      }, payload.timeout);
    });
  },
  async passwordRecovery(context: MainContext, payload: { username: string }) {
    const loadingNotification = {
      content: "Sending password recovery email",
      showProgress: true,
    };
    try {
      commitAddNotification(context, loadingNotification);
      const response = (
        await Promise.all([
          // api.passwordRecovery(payload.username),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, {
        content: "Password recovery email sent",
        color: "success",
      });
      await dispatchLogOut(context);
    } catch (error) {
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, {
        color: "error",
        content: "Incorrect username",
      });
    }
  },
  async resetPassword(
    context: MainContext,
    payload: { password: string; token: string }
  ) {
    const loadingNotification = {
      content: "Resetting password",
      showProgress: true,
    };
    try {
      commitAddNotification(context, loadingNotification);
      const response = (
        await Promise.all([
          api.resetPassword(payload.password, payload.token),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, {
        content: "Password successfully reset",
        color: "success",
      });
      await dispatchLogOut(context);
    } catch (error) {
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, {
        color: "error",
        content: "Error resetting password",
      });
    }
  },
  async actionGetMyLastProject(context: MainContext) {
    // 每个标签页使用自己 sessionStorage 里缓存的 project 独立访问不同项目。
    // 只有当本地缓存获取不到项目时，才从接口获取 last_visit_project 作为兜底，
    // 避免 token 过期重新鉴权时，用服务端唯一的 last_visit_project 覆盖本标签页的项目上下文。
    const localProject = getLocalProject();
    if (localProject && localProject !== "null" && localProject !== "undefined") {
      return;
    }
    try {
      const response = await api.getMyLastProject(context.state.token);
      if (response.data) {
        commitSetMyLastProject(context, response.data);
        saveLocalProject(String(response.data));
      }
    } catch (error: any) {
      const local_storage_project = getLocalStorageProject();
      if (local_storage_project) {
        await saveLocalProject(String(local_storage_project));
      }
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUpdateMyLastProject(
    context: MainContext,
    payload: { last_visit_project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.updateMyLastProject(context.state.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetMyLastProject(context, payload.last_visit_project);
    } catch (error: any) {
      if (error.response.status === 403) {
        return {
          data: error.response.data.data,
          message: error.response.data.message,
        };
      }
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetMobaProjects(context: MainContext, project: number) {
    try {
      const response = await api.getMobaProjects(context.state.token, project);
      if (response.data) {
        commitSetMobaProjects(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHeroSkin(context: MainContext, project: number) {
    try {
      const response = await api.getHeroSkin(context.state.token, project);
      if (response.data) {
        commitSetHeroSkin(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTaskLogs(
    context: MainContext,
    payload: { project: number; task_record_id: number }
  ) {
    try {
      const response = await api.getTaskLogs(
        context.state.token,
        payload.project,
        payload.task_record_id
      );
      if (response.data) {
        commitSetTaskLogs(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAddVisitStat(
    context: MainContext,
    payload: { module: any; dept: string | null }
  ) {
    try {
      const response = (
        await Promise.all([
          api.addVisitStat(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetStaffInfo(context: MainContext) {
    try {
      const response = await api.getStaffInfo(context.rootState.main.token);
      if (response.data) {
        commitSetStaffInfo(context, response.data);
      }
    } catch (error: any) {
      await dispatchCheckApiError(context, error);
    }
  },
};

const { dispatch } = getStoreAccessors<MainState | any, State>("");

export const dispatchCheckApiError = dispatch(actions.actionCheckApiError);
export const dispatchCheckLoggedIn = dispatch(actions.actionCheckLoggedIn);
export const dispatchGetUserProfile = dispatch(actions.actionGetUserProfile);
export const dispatchGetUsers = dispatch(actions.actionGetUsers);
export const dispatchLogIn = dispatch(actions.actionLogIn);
export const dispatchWereportLogIn = dispatch(actions.actiontWereportLogIn);
export const dispatchWechatLogIn = dispatch(actions.actionWechatLogIn);
export const dispatchLogOut = dispatch(actions.actionLogOut);
export const dispatchUserLogOut = dispatch(actions.actionUserLogOut);
export const dispatchRemoveLogIn = dispatch(actions.actionRemoveLogIn);
export const dispatchRouteLoggedIn = dispatch(actions.actionRouteLoggedIn);
export const dispatchRouteLogOut = dispatch(actions.actionRouteLogOut);
export const dispatchRemoveNotification = dispatch(actions.removeNotification);
export const dispatchGetMyLastProject = dispatch(
  actions.actionGetMyLastProject
);
export const dispatchUpdateMyLastProject = dispatch(
  actions.actionUpdateMyLastProject
);
export const dispatchGetAllIndexes = dispatch(actions.actionGetAllIndexes);
export const dispatchGetMobaProjects = dispatch(actions.actionGetMobaProjects);
export const dispatchGetHeroSkin = dispatch(actions.actionGetHeroSkin);
export const dispatchGetTaskLogs = dispatch(actions.actionGetTaskLogs);
export const dispatchAddVisitStat = dispatch(actions.actionAddVisitStat);
export const dispatchGetStaffInfo = dispatch(actions.actionGetStaffInfo);
